/**
 * Remembers the last few passengers (name/email/phone) a customer booked for, in
 * localStorage, so the first-name field can suggest them. Plain functions rather than a
 * service: used from field-wrapper and confirmation, neither of which needs DI for it.
 */
export const RECENT_PASSENGERS_KEY = 'recentPassengers';
const MAX_PASSENGERS = 5;
const PASSENGER_KEYS = ['firstName', 'lastName', 'email', 'phoneNumber', 'phoneNumberCountry', 'mobilePhone', 'countryCode', 'company'];

export function getRecentPassengers(): any[] {
  try {
    const list = JSON.parse(localStorage.getItem(RECENT_PASSENGERS_KEY) || '[]');
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function saveRecentPassenger(values: any): void {
  if (!values || !String(values.firstName || '').trim()) return;
  const passenger: any = {};
  PASSENGER_KEYS.forEach(k => {
    if (values[k] !== undefined && values[k] !== null && values[k] !== '') passenger[k] = values[k];
  });
  const sameKey = (p: any) =>
    String(p.firstName || '').toLowerCase() === String(passenger.firstName).toLowerCase() &&
    String(p.lastName || '').toLowerCase() === String(passenger.lastName || '').toLowerCase();
  const list = [passenger, ...getRecentPassengers().filter(p => !sameKey(p))].slice(0, MAX_PASSENGERS);
  try {
    localStorage.setItem(RECENT_PASSENGERS_KEY, JSON.stringify(list));
  } catch { /* storage full or blocked — skip silently */ }
}
